module.exports = __webpack_public_path__ + "static/media/AUTO-off.d47270c0.svg";